import { EnvironmentProviders, Injector, Provider } from '@angular/core';

import {
  canvasStateInitializer,
  collapsibleContainerStateInitializer,
  indicationsTableInitializer,
  layoutStateInitializer,
  ribbonStateInitializer, ROOT_STATE_TOKEN,
  tcgStateInitializer,
} from '@olympus/ngx-shared';

import { APP_STATE_INITIALIZERS, WindViewState, windViewStateInitializer } from './core/app.state';
import { readingsStateInitializer } from './core/readings.state';
import { statisticsStateInitializer } from './core/statistics.state';

export const storeProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: APP_STATE_INITIALIZERS,
    useValue: {
      ...canvasStateInitializer(),
      ...tcgStateInitializer(),
      ...windViewStateInitializer(),
      ...readingsStateInitializer(),
      ...layoutStateInitializer(),
      ...indicationsTableInitializer(),
      ...ribbonStateInitializer(),
      ...statisticsStateInitializer(),
      ...collapsibleContainerStateInitializer(),
    },
  },
  {
    provide: ROOT_STATE_TOKEN,
    useFactory: (injector: Injector): WindViewState => injector.get<WindViewState>(WindViewState),
    deps: [Injector],
  },
];
